import React, { useContext } from 'react'
import PropTypes from 'prop-types'

import { digObject } from 'functions/utilities'

import GlobalContext from 'agency/digital_renderer/utils/context'
import deviceStyle from 'agency/digital_renderer/utils/deviceStyle'

import AnimationWrapper from 'agency/digital_renderer/themes/RealhubDynamic/ui/AnimationWrapper'
import ElementContainer from '../../ElementContainer'

const findContainer = items => items.find(item => item.item_type === 'container')

const filterContacts = (contacts, campaignContactIds = [], options) => {
  const { limit, offset } = options || {}

  const filterOffset = offset && offset !== 0 ? offset : 0
  const filterLimit = limit ? limit + filterOffset : null

  if (!contacts || !campaignContactIds) return []

  const filteredContact = campaignContactIds.map((contactId) => {
    const contact = Object.values(contacts).find(c => c.id === contactId)
    return contact
  }).filter(c => c)

  const limited = filterLimit ? filteredContact.slice(filterOffset, filterLimit) : filteredContact.slice(filterOffset)

  return limited
}

const renderContacts = (contacts, contactContainer) => contacts.map(contact => (
  <div key={contact.id} style={deviceStyle(contactContainer)}>
    <ElementContainer
      forwardContextToItems={contact}
      section={contactContainer}
      renderNested
      render={({ itemComponents }) => itemComponents.map(component => component)}
    />
  </div>
))

const Contacts = (props) => {
  const { items, options } = props

  const contactsContainer = findContainer(items) || {}
  const style = deviceStyle(props)

  const defaultContext = useContext(GlobalContext)

  const {
    campaign,
    contacts: contactsEntity,
  } = defaultContext

  const campaignContactIds = digObject(campaign, 'contacts', [])

  const filteredContacts = filterContacts(contactsEntity, campaignContactIds, options)

  return (
    <AnimationWrapper>
      <div style={style}>{renderContacts(filteredContacts, contactsContainer)}</div>
    </AnimationWrapper>
  )
}

Contacts.propTypes = {
  items: PropTypes.array.isRequired,
  options: PropTypes.object,
}

export default Contacts
